var generateComponentTheme = function generateComponentTheme(_ref) {
  var borders = _ref.borders,
    colors = _ref.colors,
    spacing = _ref.spacing;
  return {
    wordbankWrapperBorder: borders.widthSmall,
    wordbankWrapperBorderColor: colors.ash,
    wordbankWrapperBorderRadius: borders.radiusMedium,
    wordbankWrapperColor: colors.porcelain,
    wordbankWrapperMargin: spacing.xSmall,
    printBorder: borders.widthSmall,
    printBorderColor: colors.ash,
    printBorderRadius: borders.radiusMedium,
    printColor: colors.porcelain,
    printMargin: spacing.xSmall
  };
};
export default generateComponentTheme;